module.exports = __webpack_public_path__ + "img/intro_pc_img05-01.a4a43faf.png";